<template>
  <header class="header">
    <div class="container custom-container">
      <nav class="navbar">
        <figure class="img-responsive" @click="home">
          <img
            src="../assets/logo-white.png"
            alt="Logo Branco Heliar Express"
          />
        </figure>
        <a href="tel:40902020" class="header--anchor">
          <div class="header--call-wrapper">
            <p>Deseja pedir por telefone?</p>
            <p>
              <span class="ligue"
                ><span class="icon icon-call"></span>Ligue:
              </span>
              <span class="numero"> 4090-2020</span>
            </p>
          </div>
        </a>
      </nav>
    </div>
  </header>
</template>

<script>
/* eslint-disable no-undef */

export default {
  name: "Header",
  components: {},
  methods: {
    home() {
      sessionStorage.setItem("cidade", "");
      sessionStorage.setItem("carro", "");
      if (this.$route.name == "home") {
        window.location.reload();
      } else {
        this.$router.push({ name: "home" });
      }
    },
  },
};
</script>

<style lang="scss">
.header {
  padding: 20px 0;
  background-color: $verde-heliar;
  .navbar {
    padding: 0;
  }
  .img-responsive {
    max-width: 220px;
    transition: all 0.3s ease;
    cursor: pointer;
    img {
      max-width: 100%;
    }
  }
  &--anchor {
    &:hover {
      text-decoration: none;
    }
  }
  &--call-wrapper {
    background-color: #25cc61;
    box-shadow: inset 0px 2px 6px 0px #0000001a;
    border-radius: 5px;
    color: $white;
    font-size: 22px;
    text-align: center;
    padding: 15px;
    .ligue {
      font-weight: 900;
      color: $cinza-escuro;
      display: inline-flex;
      align-items: center;
      text-transform: uppercase;
      font-style: italic;
    }
    .numero {
      font-weight: 900;
      display: inline-flex;
      align-items: center;
      font-style: italic;
      vertical-align: top;
      padding-left: 5px;
    }
    .icon {
      line-height: 0;
    }
    p {
      margin: 0;
    }
  }
}
@media (max-width: 1600px) {
  .header {
    &--call-wrapper {
      font-size: 20px;
    }
  }
}
@media (max-width: 1200px) {
  .header {
    &--call-wrapper {
      font-size: 18px;
    }
  }
}
@media (max-width: 991px) {
  .header {
    padding: 16px 0;
    .img-responsive {
      max-width: 255px;
    }
    &--call-wrapper {
      .icon {
        display: none;
      }
      .ligue {
        font-size: 22px;
      }
      .numero {
        font-size: 22px;
      }
    }
  }
}
@media (max-width: 767px) {
  .header {
    .img-responsive {
      max-width: 215px;
    }
    &--call-wrapper {
      font-size: 16px;
      .ligue {
        font-size: 20px;
      }
      .numero {
        font-size: 20px;
      }
    }
  }
}
@media (max-width: 575px) {
  .header {
    .img-responsive {
      width: 125px;
    }
    &--call-wrapper {
      font-size: 12px;
      padding: 10px;
      .ligue {
        font-size: 14px;
      }
      .numero {
        font-size: 14px;
      }
    }
  }
}
</style>
